import { Route, Routes } from "react-router-dom";
import { LandingPage } from "./login/LadingPage";
import { Playground } from "./playground";
import { Logout } from "./login/logout";

interface RoutingProps {

}
export function Routing(props: RoutingProps) {
    return <Routes>
        <Route path={`/`} element={<Playground />} />
        <Route path={`/start/*`} element={<LandingPage />} />
        <Route path={`/playground/*`} element={<Playground />} />
        <Route path={`/auth/*`} element={<Playground />} />
        <Route path={'/logout'} element={<Logout />} />
    </Routes>
}